import "core-js/modules/es.array.index-of";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { HttpMethod } from '@oh-auth/common';
import { PublicKeyDto, TokensDto, TokenName } from '@oh-auth/dto';
import { ApiClientRequestError } from '../api-client.errors';
import { LocationDto } from '../utils/location.dto';
export var oauthApiDefinition = {
  authorize: {
    method: HttpMethod.GET,
    path: 'oauth/authorize',
    tokenName: TokenName.ID_TOKEN,
    returnType: LocationDto,
    prepare: (_ref, dto) => {
      var {
        config
      } = _ref;

      var {
        client_id = config.CLIENT_ID
      } = dto,
          restDto = _objectWithoutProperties(dto, ["client_id"]);

      if (!client_id) throw new ApiClientRequestError('client_id is not defined');
      return {
        query: _objectSpread({}, restDto, {
          client_id
        })
      };
    }
  },
  getTokens: {
    method: HttpMethod.POST,
    path: 'oauth/token',
    tokenName: null,
    returnType: TokensDto,
    prepare: (_ref2, dto) => {
      var _dto$client_id, _dto$client_secret;

      var {
        config
      } = _ref2;
      var client_id = (_dto$client_id = dto.client_id) !== null && _dto$client_id !== void 0 ? _dto$client_id : config.CLIENT_ID;
      var client_secret = (_dto$client_secret = dto.client_secret) !== null && _dto$client_secret !== void 0 ? _dto$client_secret : config.CLIENT_SECRET;
      return {
        body: _objectSpread({}, dto, {
          client_id,
          client_secret
        })
      };
    }
  },
  revokeToken: {
    method: HttpMethod.POST,
    path: 'oauth/token/revoke',
    tokenName: null,
    prepare: (_ref3, dto) => {
      var {
        config
      } = _ref3;

      var {
        client_id = config.CLIENT_ID,
        client_secret = config.CLIENT_SECRET
      } = dto,
          restDto = _objectWithoutProperties(dto, ["client_id", "client_secret"]);

      return {
        body: _objectSpread({}, restDto, {
          client_id,
          client_secret
        })
      };
    }
  },
  signUpUser: {
    method: HttpMethod.POST,
    path: 'oauth/sign_up/user',
    tokenName: null,
    returnType: TokensDto,
    prepare: (context, dto) => ({
      body: dto
    })
  },
  signUpApp: {
    method: HttpMethod.POST,
    path: 'oauth/sign_up/user',
    tokenName: TokenName.ID_TOKEN,
    returnType: TokensDto,
    prepare: (context, dto) => ({
      body: dto
    })
  },
  signInUser: {
    method: HttpMethod.POST,
    path: 'oauth/sign_in/user',
    tokenName: null,
    returnType: TokensDto,
    prepare: (context, dto) => ({
      body: dto
    })
  },
  getPublicKey: {
    method: HttpMethod.GET,
    path: 'oauth/public_key',
    tokenName: null,
    returnType: PublicKeyDto,
    prepare: context => ({})
  }
};